export default __webpack_public_path__ + "static/14-03e9c4c2255e4a76bc5fb97505476eaa.webp";